import { zodResolver } from '@hookform/resolvers/zod'
import { conditionalRender } from '@repo/toolkit/conditional-render'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import {
  DeattachEnrollmentReasonEnum,
  deattachEnrollmentReasonEnumMapping
} from '../../../../lib/types/enums/center/deattach-enrollment-reason'
import { RemoveCenterEnrollmentsInput } from '../../../../lib/types/models/center/center-enrollment'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { getSelectedEnumOption } from '../../../../lib/utils/functions/misc.functions'
import { createEnumSchema } from '../../../../lib/utils/validations/enum-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledSelectInput from '../../../elements/inputs/controlled-select-input'
import ValidationButtons from '../../../elements/validation-buttons'

type Props = BaseFormProps<RemoveCenterEnrollmentsInput> & {
  className?: string
}

const formSchema: ZodType<RemoveCenterEnrollmentsInput> = z.object({
  reason: createEnumSchema({
    fieldName: "Motif de l'annulation",
    enumType: DeattachEnrollmentReasonEnum
  }),
  enrollmentIds: z
    .array(z.number())
    .nonempty('Veuillez sélectionner au moins une inscription à annuler')
})

export function DeaffectEnrollmentCenterForm({
  defaultValues,
  className,
  ...validationButtonProps
}: Props) {
  const form = useForm<RemoveCenterEnrollmentsInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={className}>
          <FormField
            control={form.control}
            name={'reason'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledSelectInput
                    {...field}
                    dropDownPosition="above"
                    label="Motif de l'annulation"
                    options={Object.values(DeattachEnrollmentReasonEnum).map((value) => ({
                      label: deattachEnrollmentReasonEnumMapping[value],
                      value
                    }))}
                    selectedOption={conditionalRender(
                      !!field?.value,
                      getSelectedEnumOption(field.value, deattachEnrollmentReasonEnumMapping)
                    )}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}
